import React from 'react';

const OPTIONS = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'reading', label: 'Reading' }
];

const AppearanceSelector = ({
  value,
  onChange,
  className,
  buttonClassName,
  activeButtonClassName,
  includeButtonClassName = ''
}) => (
  <div className={className} aria-label="Preview appearance">
    {OPTIONS.map((option) => (
      <button
        key={option.value}
        type="button"
        className={[
          includeButtonClassName,
          buttonClassName,
          value === option.value ? activeButtonClassName : ''
        ].filter(Boolean).join(' ')}
        onClick={() => onChange(option.value)}
        aria-pressed={value === option.value}
        title={`${option.label} mode`}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default AppearanceSelector;
